import { render, staticRenderFns } from "./ActivityTemplate.vue?vue&type=template&id=5aed56eb&scoped=true"
import script from "./ActivityTemplate.vue?vue&type=script&lang=js"
export * from "./ActivityTemplate.vue?vue&type=script&lang=js"
import style0 from "./ActivityTemplate.vue?vue&type=style&index=0&id=5aed56eb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed56eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aed56eb')) {
      api.createRecord('5aed56eb', component.options)
    } else {
      api.reload('5aed56eb', component.options)
    }
    module.hot.accept("./ActivityTemplate.vue?vue&type=template&id=5aed56eb&scoped=true", function () {
      api.rerender('5aed56eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/ActivityTemplate/ActivityTemplate.vue"
export default component.exports